import React, { RefObject } from 'react';
import { EFileExportTypes, EFileImportTypes } from 'enums/EFileExportTypes';
import {
  ImportIngredientsDTO,
  NavigatorMapDTO,
  PlateWellDTO,
} from 'business/models/Models';
import { ExperimentCanvasRoute } from 'components/Experiment/constants';

export const ExpDashboardContext = React.createContext({
  fileExportActionType: EFileExportTypes.NONE,
  setFileExportActionType: (e: EFileExportTypes) => {},
  fileImportActionType: EFileImportTypes.NONE,
  setFileImportActionType: (e: EFileImportTypes) => {},
  importedIngredientCoflicts: {},
  setImportedIngredientCoflicts: (value: ImportIngredientsDTO) => {},
  imagedWells: [],
  cursorClass: null,
  setCursorClass: null,
  canvasContainerRef: null,
  isCanvasInFocus: false,
  setIsCanvasInFocus: null,
  selectedCanvasRoute: null,
  setSelectedCanvasRoute: null,
  navigatorMap: {},
  dropImageVerticalPrefetchingCount: 0,
  dropImageHorizontalPrefetchingCount: 0,
  navigatorVerticalPrefetchingCount: 0,
  navigatorHorizontalPrefetchingCount: 0,
} as ExpDashboardContextType);

type ExpDashboardContextType = {
  fileExportActionType: EFileExportTypes;
  setFileExportActionType: (e: EFileExportTypes) => void;
  fileImportActionType: EFileImportTypes;
  setFileImportActionType: (e: EFileImportTypes) => void;
  importedIngredientCoflicts: ImportIngredientsDTO;
  setImportedIngredientCoflicts: (value: ImportIngredientsDTO) => void;
  setSelectedSidePanelTab: (...args) => void;
  selectedSidePanelTab: number;
  imagedWells: PlateWellDTO[];
  triggerZoom: (wellKey: string, zoom: number) => void;
  cursorClass: string;
  setCursorClass: React.Dispatch<React.SetStateAction<string>>;
  canvasContainerRef: RefObject<HTMLDivElement>;
  isCanvasInFocus: boolean;
  setIsCanvasInFocus: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCanvasRoute: ExperimentCanvasRoute | null;
  setSelectedCanvasRoute: React.Dispatch<
    React.SetStateAction<ExperimentCanvasRoute | null>
  >;
  navigatorMap: NavigatorMapDTO;
  dropImageVerticalPrefetchingCount: number;
  dropImageHorizontalPrefetchingCount: number;
  navigatorVerticalPrefetchingCount: number;
  navigatorHorizontalPrefetchingCount: number;
};
